import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { getPostHogClientAsync } from "@/lib/posthog/client";

export function PostHogUserIdentifier() {
  const { user, userData, loading } = useAuth();


  useEffect(() => {
    async function identifyUser() {
      const posthog = await getPostHogClientAsync();
      if (!posthog) {
        // console.log("🔍 PostHog client not available for user identification");
        return;
      }

      if (loading) {
        return; // Wait for auth to load
      }
      if (!user || !userData || !userData.tenantId) {
        return;
      }

      if (user && userData && userData.tenantId) {
        // Identify user with PostHog
        const userProperties = {
          email: user.email,
          displayName: userData.displayName,
          tenantId: userData.tenantId,
          role: userData.role || "pharmacist",
          permissions: userData.permissions,
        };

        posthog.identify(user.uid, userProperties);

        // Set user groups for role-based feature flags
        if (userData.role) {
          posthog.group("role", userData.role);
        }

        if (userData.tenantId) {
          posthog.group("tenant", userData.tenantId);
        }

        // Track login event
        posthog.capture("user_logged_in", {
          method: "session_restored",
          tenantId: userData.tenantId,
          role: userData.role,
        });

        // console.log('✅ User identified with PostHog:', user.email, 'Role:', userData.role, 'Tenant:', userData.tenantId);

        // Force feature flags to reload after user identification and wait a bit longer
        // setTimeout(() => {
        //   console.log('🔄 Reloading feature flags after user identification...');
        //   posthog.reloadFeatureFlags();

        //   // Wait a bit more then check feature flags
        //   setTimeout(() => {
        //     console.log('🔍 Feature flag test after reload:');
        //     console.log('  - feature_scanner:', posthog.isFeatureEnabled('feature_scanner'));
        //     console.log('  - feature_browser:', posthog.isFeatureEnabled('feature_browser'));
        //     console.log('  - feature_call_sms:', posthog.isFeatureEnabled('feature_call_sms'));
        //     console.log('  - feature_email:', posthog.isFeatureEnabled('feature_email'));
        //   }, 2000);
        // }, 1000);
      } else if (!loading && !user) {
        // Reset user when logged out
        console.log("🔄 Resetting PostHog user");
        posthog.reset();
      }
    }

    identifyUser();
  }, [user, userData, loading]);

  return null;
}
